import type { EventOverviewResult } from "@/types";

/** Finite numeric generations only — missing / NaN ⇒ unknown (do not coerce to 0). */
export function parseEventGeneration(value: unknown): number | undefined {
	if (typeof value !== "number" || !Number.isFinite(value)) return undefined;
	return value;
}

/**
 * When generation is unknown, ignore an explicit `event: null` wipe — partial payloads
 * must not clear the last-good overview slice.
 */
export function sanitizeOverview(
	overview: Partial<EventOverviewResult>,
): Partial<EventOverviewResult> {
	const gen = parseEventGeneration(overview.eventGeneration);
	if (gen !== undefined) return overview;

	if (!Object.prototype.hasOwnProperty.call(overview, "event")) {
		return overview;
	}

	if (overview.event !== null && overview.event !== undefined)
		return overview;

	const rest: Partial<EventOverviewResult> = { ...overview };
	delete rest.event;
	return rest;
}
